import React from 'react';
import type { FC } from 'react';
import { Box, Text } from '@wix/cli-ui-kit';
import { PreviewCommand } from '../../PreviewCommand/index.js';

interface CreatePreviewProps {
  baseUrl?: string;
  label?: string;
  onCreated: (args: { armTag: string; serverUrl: string }) => void;
}

export const CreatePreview: FC<CreatePreviewProps> = (props) => {
  const { baseUrl, label, onCreated } = props;

  return (
    <Box flexDirection="column" gap={1}>
      <Text>
        Before creating a new version, let's create a preview of your app
      </Text>
      <Box flexDirection="column">
        <PreviewCommand
          baseUrl={baseUrl}
          label={label}
          onPreviewCreated={onCreated}
          environment="production"
        />
      </Box>
    </Box>
  );
};
